import { render, staticRenderFns } from "./SaleOrderEdit.vue?vue&type=template&id=640f59ac&scoped=true"
import script from "./SaleOrderEdit.vue?vue&type=script&lang=js"
export * from "./SaleOrderEdit.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderEdit.vue?vue&type=style&index=0&id=640f59ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f59ac",
  null
  
)

export default component.exports